import { render, staticRenderFns } from "./ExampleComponent.vue?vue&type=template&id=53fa2158&"
import script from "./ExampleComponent.vue?vue&type=script&lang=js&"
export * from "./ExampleComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('53fa2158')) {
      api.createRecord('53fa2158', component.options)
    } else {
      api.reload('53fa2158', component.options)
    }
    module.hot.accept("./ExampleComponent.vue?vue&type=template&id=53fa2158&", function () {
      api.rerender('53fa2158', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "assets/js/components/ExampleComponent.vue"
export default component.exports